var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"university-banner"},[_c('img',{staticClass:"universityBannerImg",attrs:{"src":require("assets/images/learn/classRoomBannerImg.png"),"alt":""}}),_c('div',{staticClass:"bannerContent"},[_c('div',{staticClass:"w11"},[_c('p',[_vm._v("市民课堂")]),_c('span',[_vm._v(" 提高市民素质和生活品质的教育机构，为市民免费打造了一批"),_c('br'),_vm._v(" 高品质的丰富课程，供广大市民选择，欢迎广大市民踊跃报名。 ")])])])])
}]

export { render, staticRenderFns }